import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import Card from './components/AgendaContent/Card';
import config from './Config';

import FavouritesButton from './components/AgendaContent/FavouritesButton';

import { getCookie, setCookie } from '../agenda/utils/helpers';


if (document.body.contains(document.querySelector('.js_react_filter'))) {
	document.querySelectorAll('.js_react_filter').forEach((filter, index) => {
		ReactDOM.render(<App key={index} config={config} rootElement={filter} />, filter);
	});
}

const FavouritesWrapper = ({ itemid, element }) => {
	const getCookie = (name) => {
		 const value = `; ${document.cookie}`;
		 const parts = value.split(`; ${name}=`);
		 if (parts.length === 2) return parts.pop().split(';').shift();
	};

	const favouritesCookie = getCookie('mge_wishlist');
	const favouritesCookieArray = favouritesCookie ? decodeURIComponent(favouritesCookie).split(',').map(Number) : [];

	const [allFavourites, setAllFavourites] = useState(favouritesCookieArray);

	const toggleFavourite = (itemid) => {
		 setAllFavourites((prevFavourites) =>
			  prevFavourites.includes(itemid)
					? prevFavourites.filter((id) => id !== itemid)
					: [...new Set([...prevFavourites, itemid])]
		 );
	};

	return <FavouritesButton itemId={itemid} toggleFavourite={toggleFavourite} allFavourites={allFavourites} />;
};

document.querySelectorAll('.favourites-button').forEach((element) => {
	const itemid = element.dataset.itemid;
	ReactDOM.render(<FavouritesWrapper itemid={itemid} element={element} />, element);
});

if (document.body.contains(document.querySelector('.js_react_tile'))) {
   const cards = Array.from(document.querySelectorAll('.js_react_tile')).map((tile, index) => {
      const event = Object.values(JSON.parse(decodeURIComponent(tile.dataset.event)))[0];
      const show_button = tile.dataset.button;

      return (
         <Card
            key={index}
            {...event}
            config={config.mge}
            show_button={show_button}
            setTagsParam={() => {}}
         />
      );
   });

   const Wrapper = () => {
		const favouritesCookie = getCookie('mge_wishlist');
		const favouritesCookieArray = favouritesCookie ? decodeURIComponent(favouritesCookie).split(',').map(Number) : [];

		const [allFavourites, setAllFavourites] = useState(favouritesCookieArray);

		const toggleFavourite = (itemId) => {

			// Check if itemId is already in allFavourites:
			if (allFavourites.includes(itemId)) {
				setAllFavourites((prevFavourites) => prevFavourites.filter((id) => id !== itemId));
			} else {
				const newFavourites = [...allFavourites, itemId];
				setAllFavourites([...new Set([...favouritesCookieArray, ...newFavourites])]);
			}
		};

		useEffect(() => {
			// Set the cookie with allFavourites:
			setCookie('mge_wishlist', allFavourites.join(','), 7);
		}, [allFavourites]);

		return (
			<>
				{React.Children.map(cards, child => {
                return React.cloneElement(child, { allFavourites, toggleFavourite });
            })}
			</>
   )};

   // Render the wrapper component with all cards into the first js_react_tile element
   ReactDOM.render(<Wrapper />, document.querySelector('.js-featured-events'));
}
